export const FIELD_NAMES = {
  TIMER_OPTION: 'timerOption',
  TIMER_DELAY: 'timerDelay',
  NEW_TIMER_MINUTES: 'newTimerMinutes',
  SESSION_TYPE: 'sessionType',
}

export const TIMER_OPTIONS = {
  DEFAULT: 'DEFAULT',
  NEW: 'NEW',
}

export const DEFAULT_VALUES = {
  [FIELD_NAMES.TIMER_OPTION]: TIMER_OPTIONS.NEW,
  [FIELD_NAMES.TIMER_DELAY]: 0,
  [FIELD_NAMES.NEW_TIMER_MINUTES]: 10,
}
